/**
 * @generated SignedSource<<5ec95094f4eaf95b6ea6233997fc4ccb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useIsUserViewingSpaceAsAnon_space$data = {
  readonly currentUser: {
    readonly isAnonymouslyAuthorized: boolean;
  };
  readonly id: string | null;
  readonly " $fragmentType": "useIsUserViewingSpaceAsAnon_space";
};
export type useIsUserViewingSpaceAsAnon_space$key = {
  readonly " $data"?: useIsUserViewingSpaceAsAnon_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsUserViewingSpaceAsAnon_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useIsUserViewingSpaceAsAnon_space",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "SpaceUserMetadata",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAnonymouslyAuthorized"
        }
      ]
    }
  ],
  "type": "Space"
};

(node as any).hash = "af78d76c454aa1c9a6bc480bc1d76f7a";

export default node;
